<template lang="html">
  <div>
    <v-header backTo="Login empresa"></v-header>
    <v-page class="page-recover-pass" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">
      <div class="autoRegister">
        <v-login class="card-recover-pass">
          <div class="center">
            <div class="registerLeft">
              <div class="company">
                <p>E</p>
                <p>M</p>
                <p>P</p>
                <p>R</p>
                <p>E</p>
                <p>S</p>
                <p>A</p>
              </div>
              <div>
                <img class="photo" :src="img_url">
              </div>
            </div>
            <div class="registerRight">
              <v-inner>
                <div v-if="sent">
                  <v-logo class="mb-4" />
                  <v-text>Senha modificada com sucesso.</v-text>
                  <v-button class="block primary mt-2" @click="gotToLogin()">Ir para o login</v-button>
                </div>
                <form v-else @submit.prevent="send()">
                  <v-logo class="mb-4" />
                  <v-text tag="h2" class="title h4 center mb-3">Criar nova senha</v-text>
                  <v-input type="password" v-model="password" placeholder="Nova senha"/>
                  <v-input type="repassword" :repassword="password" v-model="repassword" placeholder="Repetir nova senha"/>
                  <small v-if="showTerms">
                    <v-input type="checkbox" id="login-remember" v-model="accepted_term">
                      Declaro que li e concordo com os
                      <v-link :to="{ name: 'accept' }" target="_blank">termos de aceite da plataforma Vibbra</v-link>
                    </v-input>
                  </small>
                  <v-button type="submit" class="block primary mt-2" :disabled="!accepted_term">Enviar</v-button>
                </form>
              </v-inner>
            </div>
          </div>
        </v-login>
      </div>
    </v-page>
  </div>
</template>

<script>
import apiClient from '@/api/client';
import apiVibbrante from '@/api/vibbrante';


export default {
  props: {
    profile: String,
  },
  data() {
    return {
      sent: false,
      password: '',
      repassword: '',
      accepted_term: false,
      img_url: require('../../assets/photoPeople/Lucas.png'),
      img_background_url: require('../../assets/background/fundoAzul.svg'),
      showTerms: this.$route.query.confirm,
    };
  },
  mounted() {
    // Verifica se o query param 'confirm=true' está presente
    const confirm = this.$route.query.confirm;
    console.log("confirm", confirm)

    // Atualiza a propriedade `showTerms` se `confirm` for true
    if (confirm) {
      this.showTerms = true;
    } else {
      this.accepted_term = true;
    }
  },
  methods: {
    gotToLogin() {
      if (this.profile === 'vibbrant') {
        this.$router.push({ name: 'vibbrant-login' });
      } else {
        this.$router.push({ name: 'client-login' });
      }
    },
    send() {
      if (this.profile === 'vibbrant') {
        apiVibbrante
          .updatePass(this.password, this.repassword, this.$route.query)
          .then(response => {
            if (response.status === 200) {
              this.sent = true;
            }
          });
      } else {
        apiClient
          .updatePass(this.password, this.repassword, this.$route.query)
          .then(response => {
            if (response.status === 200) {
              if(this.showTerms){
                apiClient.acceptTerms({});
                this.$router.push({ name: 'client-dashboard' });
              } else {
                this.sent = true;
              }
            }
          });
      }
    },
  },
};
</script>

<style lang="scss">
.linkLogin {
  color: white;
}

.page-recover-pass {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .autoRegister {
    width: 75%;
  }

  .card-recover-pass {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;

    @include media-breakpoint-up(md) {
      width: 100%;
    }

    .center {
      display: flex;
      align-items: center;
      padding: 2rem 2rem 0 0;

      @include media-breakpoint-down(md) {
        padding: 2rem;
      }
    }

    .registerLeft {
      display: flex;
      align-items: flex-end;
      height: 100%;
      width: 60%;

      @include media-breakpoint-down(md) {
        display: none;
      }

      .photo {
        display: block;
        height: 700px;
        margin-top: 6px;
      }

      .company {
        background-color: #0377aa;
        color: white;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px 25px;
        height: calc(100vh - 450px);
        align-items: center;
        font-weight: 700;
        font-size: 20px;
        border-radius: 0 10px 0 20px;

        p {
          margin: 0;
        }
      }
    }

    .registerRight {
      width: 40%;

      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }
  }

  .title {
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 40px;

    @include media-breakpoint-down(md) {
      font-size: 30px;
    }
  }

  .block {
    background-color: #0377aa;
    color: white;
  }

  .primary {
    background-color: #0377aa;
    color: white;
  }

  footer.page-footer {
    margin-top: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/new-pass.vue